
import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

export default function CommentDeletePopup({ Open, handleMainClose,handleCommentDelete }) {
    const [open, setOpen] = React.useState(Open);
    const handleClose = () => {
        setOpen(false)
        handleCommentDelete();
    };
   
    return (
        <div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>

                    <div>
                        <p>Are you sure to Delete this Comment</p>
                        <Button onClick={()=>handleMainClose()}>ok</Button>
                        <Button onClick={handleClose}>Cancel</Button>
                    </div>


                </Box>
            </Modal>
        </div>
    );
}
